import { render } from "./PayoutsOverview.vue?vue&type=template&id=ddf01060&scoped=true"
import script from "./PayoutsOverview.vue?vue&type=script&lang=js"
export * from "./PayoutsOverview.vue?vue&type=script&lang=js"

import "./PayoutsOverview.vue?vue&type=style&index=0&id=ddf01060&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ddf01060"]])

export default __exports__